
export const environment = {
    envName: 'prod',
    production: true,
    hostname: 'uniontracker.toyota.com',
    apiBaseUrl: 'https://uniontracker.toyota.com',
    logger: {
      level: 'INFO'
    },
    xApiKey: '',
    TENANT_ID: 'https://login.microsoftonline.com/8c642d1d-d709-47b0-ab10-080af10798fb',
    CLIENT_ID: '359510b2-bd5e-4e41-a1e4-ea4ec304aabd',
    REDIRECT_URL: 'https://uniontracker.toyota.com',
    apiUrl: {
      lookupUrl: 'https://api.uniontracker.toyota.com/lookup/',
      suppliermanagUrl: 'https://api.uniontracker.toyota.com/management/'
    }
  };
  